import React from "react";
import openSquirrelUrl from "open-squirrel.svg";
import styles from "components/manage-envelopes/no-envelopes.scss";

export const NoEnvelopes = () => (
  <div>
    <div className={ styles.container }>
      <img alt={ "open arms squirrel" } src={ openSquirrelUrl } />
      <h3>It doesn&apos;t look like you have any envelopes. Click the request an envelope to get started!</h3>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/js/components/manage-envelopes/no-envelopes.jsx